import { apiClient } from './api'

export interface SLAConfig {
  org_id: number
  change_request_sla_hours: number
  escalation_user_id?: number
  compliance_threshold: number
  block_on_overdue_review: boolean
  updated_at: string
}

export interface OverdueChangeRequest {
  id: number
  program_id: number
  title: string
  request_type: string
  status: string
  sla_deadline?: string
  escalated_at?: string
  created_at: string
  hours_overdue: number
}

export interface AuditLogEntry {
  id: number
  user_id?: number
  entity_type: string
  entity_id?: number
  action: string
  description?: string
  extra_data?: Record<string, unknown>
  created_at: string
  /** Who did it (full name, or email). Null for system events. */
  user_name?: string | null
}

export interface AuditTrailFilters {
  entity_type?: string
  entity_id?: number
  user_id?: number
  action?: string
  from_date?: string
  to_date?: string
  limit?: number
  offset?: number
}

export const governanceSlaService = {
  getConfig: async (): Promise<SLAConfig> => {
    const { data } = await apiClient.get('/api/v1/governance/sla-config')
    return data
  },

  updateConfig: async (updates: Partial<Omit<SLAConfig, 'org_id' | 'updated_at'>>): Promise<SLAConfig> => {
    const { data } = await apiClient.put('/api/v1/governance/sla-config', updates)
    return data
  },

  getOverdueRequests: async (): Promise<OverdueChangeRequest[]> => {
    const { data } = await apiClient.get('/api/v1/governance/overdue-change-requests')
    return data
  },

  escalateOverdue: async (): Promise<{ escalated: number }> => {
    const { data } = await apiClient.post('/api/v1/governance/escalate-overdue')
    return data
  },

  getAuditTrail: async (filters: AuditTrailFilters = {}): Promise<AuditLogEntry[]> => {
    const { data } = await apiClient.get('/api/v1/governance/audit-trail', { params: filters })
    return data
  },
}
